import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AbstractLogger } from './app/api/Logger/AbstractLogger';

if (environment.production) {
  enableProdMode();
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('logger-service-worker.js')
    .then(() => navigator.serviceWorker.ready)
    .then((registration) => {
      const worker = navigator.serviceWorker.controller ?? registration.active ?? registration.waiting ?? registration.installing ?? null;
      AbstractLogger.setServiceWorker(worker);
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        AbstractLogger.setServiceWorker(navigator.serviceWorker.controller);
      });
    })
    .catch(() => {
      AbstractLogger.setServiceWorker(null);
    });
} else {
  AbstractLogger.setServiceWorker(null);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
